module.exports = __webpack_public_path__ + "static/media/canari_logo_patrick.0b7f37fb.png";